import { CollaboratorDeductionSettingsResponse } from "app/types/Ajustes";
import { DeductionPost, DeductionResonse } from "app/types/deductions";
import axios from "axios";

const NET_URL = process.env.REACT_APP_API_NET;

export const postDeductions = async (body: DeductionPost) => {
    return axios.post(`${NET_URL}CollaboratorDeduction`, body);
};

export const postDeductionsSecondRoster = async (body: DeductionPost) => {
    return axios.post(`${NET_URL}CollaboratorDeductionSecondRoster`, body);
};

export async function getCollaboratorDeductions(collaboratorId: number | string) {
    const data = await axios.get<DeductionResonse>(`${NET_URL}CollaboratorDeduction/${collaboratorId}/collaborator`);
    return data.data.data;
};

export async function getCollaboratorDeductionsSettings(collaboratorId: number | string | undefined) {
    const data = await axios.get<CollaboratorDeductionSettingsResponse>(`${NET_URL}CollaboratorDeduction/${collaboratorId}/collaborator`);
    return data.data.data;
};

export async function getCollaboratorDeductionsSecondRosterSettings(collaboratorId: number | string | undefined, periodId: number | string | undefined) {
    try {
        const data = await axios.get<CollaboratorDeductionSettingsResponse>(`${NET_URL}CollaboratorDeductionSecondRoster/${collaboratorId}/${periodId}/collaborator`);
        return data.data.data;
    }catch(err){
        return [];
    }
};

export const putDeductions = async (id: number, body: any) => {
    return axios.put(`${NET_URL}CollaboratorDeduction/${id}`, body);
};

export const deleteCollaboratorDeductionSecondRoster = async (id: number) => {
    return axios.delete(`${NET_URL}CollaboratorPerceptionSecondRoster/${id}`);
};